import React, { useState, useEffect, useCallback } from 'react'
import './heroSection.css'
import heroBg from '../../assets/fundo-video.mp4'

const slides = [
    {
        overline: 'Desenvolvimento SAP & Mobile',
        title: 'Transformamos processos\nem resultados',
        subtitle:
            'Aplicativos Fiori, integrações BTP, customizações ABAP e apps mobile que eliminam o retrabalho e elevam a eficiência da sua empresa.',
        cta: { label: 'Conheça nossas soluções', target: 'section2-role' },
    },
    {
        overline: 'Especialistas em Ecossistema SAP',
        title: 'Do ABAP ao BTP,\ndomínamos toda a stack SAP',
        subtitle:
            'Desenvolvemos soluções que se encaixam perfeitamente nos processos já existentes — sem retrabalho, com documentação completa e arquitetura limpa.',
        cta: { label: 'Ver Cases de Sucesso', target: 'cases-role' },
    },
    {
        overline: 'Projetos entregues no prazo',
        title: 'Da ideia ao Go-Live\nem semanas',
        subtitle:
            'Mais de 200 projetos entregues para 15+ empresas de diferentes setores. Metodologia ágil, comunicação transparente e suporte pós-entrega.',
        cta: { label: 'Fale com um especialista', target: 'dialog' },
    },
]

export default function HeroSection({ handleDialogOpen }) {
    const [current, setCurrent] = useState(0)
    const [visible, setVisible] = useState(true)

    const goTo = useCallback((index) => {
        setVisible(false)
        setTimeout(() => {
            setCurrent(index)
            setVisible(true)
        }, 350)
    }, [])

    useEffect(() => {
        const timer = setInterval(() => {
            goTo((current + 1) % slides.length)
        }, 9000)
        return () => clearInterval(timer)
    }, [current, goTo])

    function handleCta(target) {
        if (target === 'dialog') {
            handleDialogOpen && handleDialogOpen()
            return
        }
        const el = document.getElementById(target)
        if (el) el.scrollIntoView({ behavior: 'smooth' })
    }

    const slide = slides[current]

    return (
        <div id="hero-section">
            {/* Video background — place hero-bg.mp4 in /public */}
            <video
                className="hero-video"
                autoPlay
                muted
                loop
                playsInline
                src={heroBg}
            />
            <div className="hero-overlay" />

            <div className={`hero-content ${visible ? 'hero-visible' : 'hero-hidden'}`}>
                <div className="container h-100">
                    <div className="row h-100 align-items-center">
                        <div className="col-12 col-md-9 col-lg-7">
                            <span className="hero-overline">{slide.overline}</span>
                            <h1 className="hero-title">
                                {slide.title.split('\n').map((line, i) => (
                                    <React.Fragment key={i}>
                                        {line}
                                        {i < slide.title.split('\n').length - 1 && <br />}
                                    </React.Fragment>
                                ))}
                            </h1>
                            <p className="hero-subtitle">{slide.subtitle}</p>
                            <button
                                className="hero-cta"
                                onClick={() => handleCta(slide.cta.target)}
                            >
                                {slide.cta.label}
                            </button>
                        </div>
                    </div>
                </div>

                {/* Slide indicators */}
                <div className="hero-dots">
                    {slides.map((_, i) => (
                        <button
                            key={i}
                            className={`hero-dot ${i === current ? 'hero-dot-active' : ''}`}
                            onClick={() => goTo(i)}
                            aria-label={`Slide ${i + 1}`}
                        />
                    ))}
                </div>
            </div>
        </div>
    )
}
